import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import Home from '@/views/Home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    meta: {
      title: 'StarTimes ON'
    }
  },
  {
    path: '/index.html',
    component: () => import('@/views/redirect.vue'),
    meta: {
      title: 'StarTimes ON'
    }
  },
  {
    path: '/activity',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/activity/Index.vue'),
        meta: {
          title: 'StarTimes ON'
        }
      },
      {
        path: 'newdvb',
        meta: {
          title: 'Gift Packs For You'
        },
        component: () => import('@/views/activity/NewDVB.vue')
      },
      {
        path: 'ugdvbbind',
        meta: {
          title: 'Get linked and Win a Smart phone'
        },
        component: () => import('@/views/activity/UGDVBBind.vue')
      },
      {
        path: 'bssregister',
        meta: {
          title: 'Bongo Star Search 2023'
        },
        component: () => import('@/views/activity/BSSRegister.vue')
      },
      {
        path: 'bssvote',
        meta: {
          title: 'Bongo Star Search 2023'
        },
        component: () => import('@/views/activity/BSSVote.vue')
      },
      {
        path: 'bssvotedetail',
        meta: {
          title: 'Bongo Star Search 2023'
        },
        component: () => import('@/views/activity/BSSVoteDetail.vue')
      },
      {
        path: 'bssresult',
        meta: {
          title: 'Bongo Star Search 2023'
        },
        component: () => import('@/views/activity/BSSResult.vue')
      },
      {
        path: 'bsstopic',
        meta: {
          title: 'Bongo Star Search 2020'
        },
        component: () => import('@/views/activity/BSSTopic.vue')
      },
      {
        path: 'bsscomment',
        meta: {
          title: 'Bongo Star Search 2020'
        },
        component: () => import('@/views/activity/BSSComment.vue')
      },
      {
        path: 'bsshivpost',
        meta: {
          title: 'BSS | TACAIDS'
        },
        component: () => import('@/views/activity/BSSHIVPost.vue')
      },
      {
        path: 'bsshiv',
        meta: {
          title: 'BSS | TACAIDS'
        },
        component: () => import('@/views/activity/BSSHIV.vue')
      },
      {
        path: 'bssmentor',
        meta: {
          title: 'Bongo Star Search 2020'
        },
        component: () => import('@/views/activity/BSSMentor.vue')
      },
      {
        path: 'bssfinals',
        meta: {
          title: 'Bongo Star Search 2020'
        },
        component: () => import('@/views/activity/BSSFinals.vue')
      },
      {
        path: 'bsspopular2023',
        meta: {
          title: 'Bongo Star Search 2023'
        },
        component: () => import('@/views/activity/BSSPopular2023.vue')
      },
      {
        path: 'europeancup',
        meta: {
          title: 'EURO2020 Prediction'
        },
        component: () => import('@/views/activity/EuropeanCup.vue')
      },
      {
        path: 'europeancup2',
        meta: {
          title: 'EURO2020 Prediction'
        },
        component: () => import('@/views/activity/EuropeanCup2.vue')
      },
      {
        path: 'varietyvote',
        meta: {
          title: 'Kura za Usaili wa'
        },
        component: () => import('@/views/activity/VarietyVote.vue')
      },
      {
        path: 'varietyvote2',
        meta: {
          title: 'BINGWA'
        },
        component: () => import('@/views/activity/VarietyVote2.vue')
      },
      {
        path: 'mrrightregistertz',
        meta: {
          title: 'Hello Mr Right'
        },
        component: () => import('@/views/activity/MrRightRegisterTZ.vue')
      },
      {
        path: 'mrrightvotetz',
        meta: {
          title: 'Hello Mr Right'
        },
        component: () => import('@/views/activity/MrRightVoteTZ.vue')
      },
      {
        path: 'covidivide',
        meta: {
          title: 'COVID-19 Situation Update'
        },
        component: () => import('@/views/activity/covidivide')
      },
      {
        path: 'covidivide.html',
        redirect: '/activity/covidivide'
      },
      {
        path: 'leaguematch',
        meta: {
          title: 'Predictive Activity'
        },
        component: () => import('@/views/activity/LeagueMatch.vue')
      },
      {
        path: 'comedy',
        meta: {
          title: 'The Best Comedy Challenge'
        },
        component: () => import('@/views/activity/Comedy.vue')
      },
      {
        path: 'oscar',
        meta: {
          title: 'AMAA-StarTimes Short Film Festival'
        },
        component: () => import('@/views/activity/Oscar.vue')
      },
      {
        path: 'misstz',
        meta: {
          title: 'Miss Tanzania 2022'
        },
        component: () => import('@/views/activity/MissTZ.vue')
      },
      {
        path: 'mrrightregisterng',
        meta: {
          title: 'Hello Mr.Right'
        },
        component: () => import('@/views/activity/MrRightRegisterNG.vue')
      },
      {
        path: 'appvote',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/activity/AppVote.vue')
      },
      {
        path: 'bssregister2024',
        meta: {
          title: 'Bongo Star Search 2024'
        },
        component: () => import('@/views/activity/BSSRegister2024.vue')
      },
      {
        path: 'bssvote2024',
        meta: {
          title: 'Bongo Star Search 2024'
        },
        component: () => import('@/views/activity/BSSVote2024.vue')
      },
      {
        path: 'bssvotedetail2024',
        meta: {
          title: 'Bongo Star Search 2024'
        },
        component: () => import('@/views/activity/BSSVoteDetail2024.vue')
      },
      {
        path: 'bssresult2024',
        meta: {
          title: 'Bongo Star Search 2024'
        },
        component: () => import('@/views/activity/BSSResult2024.vue')
      },
      {
        path: 'kssregister',
        meta: {
          title: 'Kenya Star Search 2024'
        },
        component: () => import('@/views/activity/KSSRegister.vue')
      },
      {
        path: 'bsspopular2024',
        meta: {
          title: 'Bongo Star Search 2024'
        },
        component: () => import('@/views/activity/BSSPopular2024.vue')
      },
      {
        path: 'multipledevices',
        meta: {
          title: 'Startimes ON'
        },
        component: () => import('@/views/activity/MultipleDevices.vue')
      }
    ]
  },
  {
    path: '/lands',
    component: Layout,
    children: [
      {
        path: '',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/lands/Index.vue')
      },
      {
        path: 'recall.html',
        redirect: '/lands'
      }
    ]
  },
  {
    path: '/onelink',
    component: Layout,
    children: [
      {
        path: '',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/onelink/Index.vue')
      }
    ]
  },
  {
    path: '/clause',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/clause/Index.vue'),
        meta: {
          title: 'StarTimes ON'
        }
      },
      {
        path: 'autorenewal',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/clause/AutoRenewal.vue')
      },
      {
        path: 'privacypolicy',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/clause/PrivacyPolicy.vue')
      },
      {
        path: 'termsofservice',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/clause/TermsOfService.vue')
      },
      {
        path: 'luckydrawpromotion',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/clause/LuckyDrawPromotion.vue')
      },
      {
        path: 'commentsguidelines',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/clause/CommentsGuidelines.vue')
      },
      {
        path: 'screenhelp',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/clause/ScreenHelp.vue')
      },
      {
        path: 'screenhelptv',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/clause/ScreenHelpTV.vue')
      }
    ]
  },
  {
    path: '/native',
    component: Layout,
    children: [
      {
        path: 'guide',
        meta: {
          title: 'Guide'
        },
        component: () => import('@/views/native/guide.vue')
      },
      {
        path: 'guidepage',
        meta: {
          title: 'Guide'
        },
        component: () => import('@/views/native/guidepage.vue')
      },
      {
        path: 'guide.html',
        redirect: '/native/guide'
      },
      {
        path: 'exchangecode',
        meta: {
          title: 'Exchange Code'
        },
        component: () => import('@/views/native/exchangeCode.vue')
      }
    ]
  },
  {
    path: '/template',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/template/Index.vue'),
        meta: {
          title: 'StarTimes ON'
        }
      },
      {
        path: 'dvbincrease',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/template/DVBIncrease.vue')
      },
      {
        path: 'dvbrecharge',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/template/DVBRecharge.vue')
      },
      {
        path: 'hmrquestionnaire',
        meta: {
          title: 'Tafuta Mr Right wako'
        },
        component: () => import('@/views/template/HMRQuestionnaire.vue')
      },
      {
        path: 'vote',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/template/Vote.vue')
      },
      {
        path: 'votelottery',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/template/VoteLottery.vue')
      },
      {
        path: 'guidebind',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/template/GuideBind.vue')
      },
      {
        path: 'userfission',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/template/UserFission.vue')
      },
      {
        path: 'land',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/template/Land.vue')
      },
      {
        path: 'unitmember',
        meta: {
          title: 'StarTimes ON'
        },
        component: () => import('@/views/template/UnitMember.vue')
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
